import css from 'styled-jsx/css';

export default css`.posts__header {
  padding: 16px 16px 0;
  font-weight: 500;
  letter-spacing: .4px;
  color: #414141; }

.posts__grid {
  padding: 1px 0 8px; }
  .posts__grid :global(.masonry-autosizer) :global(.masonry-center) {
    margin-left: auto; }

.posts__contentFooter {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  align-items: center; }

.posts :global(.masonry-layout) {
  min-height: unset; }
`